export default (state, action) => ({
  ...state,
  shareModalOpen: true,
  shareStep: action.step,
});
